module.exports = __webpack_public_path__ + "img/3.a8c56b7e.jpg";